import React from 'react';
import { helpStatuses, accountRoles, HelpAudience } from './helpPresentation';
export default function HelpRequestList({
  t,
  inbox,
  master,
  admin,
  rosterTitle,
  unread,
  total,
  searchInput,
  setSearchInput,
  search,
  setSearch,
  filter,
  setFilter,
  assignment,
  setAssignment,
  loading,
  rows,
  selected,
  openRequest,
  date,
  cursor,
  loadList,
  setError,
}) {
  return (
    <aside className="hc-roster" aria-label={t(rosterTitle)}>
      <div className="hc-roster-head">
        <h2>
          {t(rosterTitle)}{' '}
          {unread > 0 && (
            <span className="hc-unread" aria-label={t('{count} unread', { count: unread })}>
              {unread}
            </span>
          )}
        </h2>
        <span>{total === 1 ? t('1 request') : t('{count} requests', { count: total })}</span>
      </div>
      <form
        className="hc-search"
        onSubmit={(e) => {
          e.preventDefault();
          setSearch(searchInput.trim());
        }}
      >
        <span className="hc-search-field">
          <input
            aria-label={t('Search requests')}
            maxLength={120}
            placeholder={t(admin ? 'Keyword, ID, name or email' : 'Keyword or Help ID')}
            title={t(
              admin
                ? 'Search subjects, messages, Help IDs, names or emails.'
                : 'Search subjects, messages or Help IDs.'
            )}
            value={searchInput}
            onChange={(e) => {
              setSearchInput(e.target.value);
              if (!e.target.value.trim()) setSearch('');
            }}
          />
          {searchInput && (
            <button
              type="button"
              className="hc-search-clear"
              aria-label={t('Clear search')}
              title={t('Clear search')}
              onClick={() => {
                setSearchInput('');
                setSearch('');
              }}
            >
              <span aria-hidden="true">×</span>
            </button>
          )}
        </span>
        <button type="submit">{t('Search')}</button>
      </form>
      <div className="hc-filters">
        <select
          aria-label={t('Request status')}
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        >
          {(inbox
            ? ['needs_support', 'waiting_on_user', 'resolved', 'all']
            : ['open', 'resolved', 'all']
          ).map((status) => (
            <option key={status} value={status}>
              {t(helpStatuses[status] || (status === 'open' ? 'Open requests' : 'All requests'))}
            </option>
          ))}
        </select>
        {inbox && (
          <select
            aria-label={t('Assignment filter')}
            value={assignment}
            onChange={(e) => setAssignment(e.target.value)}
          >
            <option value="all">{t('All admins')}</option>
            <option value="mine">{t('Assigned to me')}</option>
            <option value="unassigned">{t('Unassigned')}</option>
          </select>
        )}
      </div>
      <div className="hc-request-list">
        {loading ? (
          <p className="hc-empty" role="status">
            {t('Loading requests…')}
          </p>
        ) : rows.length === 0 ? (
          <div className="hc-empty">
            <h3>{t(search ? 'No matching requests' : 'No requests here yet')}</h3>
            <p>
              {t(
                search
                  ? 'Try another keyword or Help ID, or change your filters.'
                  : admin
                    ? 'Requests from clinics, distributors and sales reps will appear here.'
                    : 'Start a request whenever you need a hand.'
              )}
            </p>
          </div>
        ) : (
          rows.map((row) => (
            <button
              className={`hc-request-row ${selected === row._id ? 'hc-selected' : ''}`}
              key={row._id}
              onClick={() => openRequest(row._id)}
              aria-current={selected === row._id ? 'true' : undefined}
            >
              <span className="hc-request-top">
                <span className="hc-request-person">
                  <strong>{row.requester.name}</strong>
                  {accountRoles[row.requester.role] && (
                    <span className="hc-account-role">{t(accountRoles[row.requester.role])}</span>
                  )}
                </span>
                <time dateTime={row.lastMessageAt || row.updatedAt}>
                  {date(row.lastMessageAt || row.updatedAt)}
                </time>
              </span>
              <HelpAudience request={row} />
              <span className="hc-request-subject">{row.subject}</span>
              <span className="hc-request-bottom">
                <span className="hc-request-reference">{row.reference}</span>
                <span className="hc-request-badges">
                  {row.unreadCount > 0 && (
                    <span className="hc-unread">
                      {t('{count} unread', { count: row.unreadCount })}
                    </span>
                  )}
                  <span className={`hc-status hc-${row.status}`}>
                    {t(helpStatuses[row.status])}
                  </span>
                </span>
              </span>
            </button>
          ))
        )}
      </div>
      {cursor && (
        <button
          className="hc-load-more"
          onClick={() =>
            loadList(cursor).catch(() =>
              setError(t('Could not load requests. Refresh to try again.'))
            )
          }
        >
          {t('Load more requests')}
        </button>
      )}
    </aside>
  );
}
